import { FC, SVGProps } from 'react'

const SettingsAdminIcon: FC<SVGProps<SVGSVGElement>> = svgProps => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="settings-admin-icon"
    {...svgProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.97872 16H9.02128C9.02128 16 9.15482 13.8013 10.2128 13.3333C11.3048 12.8503 13.1064 14.3333 13.1064 14.3333L14.4681 13C14.4681 13 13.0432 11.373 13.4468 10.3333C13.8484 9.29907 16 9 16 9V7C16 7 13.8101 6.7144 13.4468 5.66667C13.1015 4.67098 14.4681 3.16667 14.4681 3.16667L13.1064 1.83333C13.1064 1.83333 11.4529 3.20678 10.383 2.83333C9.20658 2.42273 9.02128 0 9.02128 0H6.97872C6.97872 0 7.15924 2.27662 6.12766 2.83333C5.00333 3.4401 3.06383 1.66667 3.06383 1.66667L1.53191 3.16667C1.53191 3.16667 2.89848 4.67098 2.55319 5.66667C2.18985 6.7144 0 7 0 7V9C0 9 2.0713 9.1981 2.55319 10.1667C3.06906 11.2035 1.70213 13 1.70213 13L2.89362 14.1667C2.89362 14.1667 4.68875 12.6977 5.78723 13.1667C6.90747 13.6449 6.97872 16 6.97872 16ZM8.00003 11C9.69213 11 11.0639 9.65685 11.0639 8C11.0639 6.34315 9.69213 5 8.00003 5C6.30792 5 4.9362 6.34315 4.9362 8C4.9362 9.65685 6.30792 11 8.00003 11Z"
      fill="currentColor"
    />
  </svg>
)

export default SettingsAdminIcon
